import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import { media } from '../themes/theme';
import { FocusStyles } from '../../styles/FocusStyles';
import Icon from '../Icon';
import { Headline2, Paragraph } from '../../src/atoms/Typography';
import { CardOuter } from './shared';
const DISMISS_ICON_SIZE = 20;
const Card = styled(CardOuter) `
  height: 100%;
`;
const Inner = styled.span `
  display: flex;
  flex-flow: row nowrap;

  height: 100%;
  padding: 0 1rem;
  align-items: center;

  @media (min-width: 25rem) {
    padding: 0 1rem 0 2rem;
  }

  ${media.tablet `
    padding: 0 1rem 0 3.5rem;
    align-items: center;
  `}

  @media (min-width: 40rem) {
    padding: 1rem 2rem;
  }
`;
const Media = styled.span `
  display: none;

  ${media.mobileM `
    margin-right: 1rem;
    flex-basis: 40%;
    display: block;
  `}

  @media (min-width: 25rem) {
    flex-basis: 33%;
  }

  @media (min-width: 35rem) {
    flex-basis: 22%;
  }

  ${media.tablet `
    flex-basis: 42%;
    position: relative;
    top: 1rem;
  `}

  ${media.laptop `
    margin-right: 2rem;
  `}
`;
const Content = styled.span `
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;

  ${media.mobileM `
    flex-basis: 60%;
  `}
`;
const Wrapper = styled.span `
  padding: 1rem 0;
  background-image: url('data:image/svg+xml;utf8,%3Csvg%20viewBox%3D%220%200%2076%2064%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20stroke-linejoin%3D%22round%22%20stroke-miterlimit%3D%222%22%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M-17-9.367h93V64h-93z%22%2F%3E%3C%2FclipPath%3E%3Cg%20clip-path%3D%22url(%23a)%22%3E%3Cpath%20d%3D%22M77.893-15.29C75.618%207.599%2065.878%2050.588%2042.564%2061.774%2019.754%2072.719-91.296%2036.89-111.228%2013.076c-18.428-22.058-19.51-43.979-16.236-76.923%203.232-32.514%208.975-71.482%2037.38-85.149%2026.187-12.59%20136.97%2013.846%20151.753%2029.155%2023%2023.82%2018.965%2076.967%2016.224%20104.55v.001z%22%20fill%3D%22%23fac800%22%2F%3E%3C%2Fg%3E%3Cg%3E%3Cpath%20d%3D%22M30.83%2011.296c1.358%200%202.375%200%203.562.678.34.226%201.188.678%201.526%201.355v1.356c0%201.808-.338%204.743-2.035%205.648-.848.452-2.035.676-2.883.452-.849-.227-1.357-.905-1.866-1.582-.34-.679-.679-1.13-.848-2.033-.17-.678.17-1.582.17-2.26.17-.452.17-.904.339-1.356l1.186-1.58c.34-.226.85-.451%201.358-.451l-.509-.227z%22%20fill%3D%22%23fefefe%22%2F%3E%3Cpath%20d%3D%22M34.841%2018.94c-1.227%202.137-4.329%202.201-5.56.098-1.546-2.637-.437-6.881%202.117-7.22.102-.015.139-.113.143-.22%201.5.037%203.754.302%204.164%202.276.302%201.448-.211%203.926-.865%205.066m1.291-5.203c-.365-2.625-3.818-2.732-5.36-2.737-.118%200-.156.103-.146.223a.415.415%200%2000.022.185c-1.907.789-3.223%203.842-2.386%206.458.96%203.007%203.355%203.915%205.541%202.835%201.903-.94%202.68-4.458%202.33-6.964%22%20fill%3D%22%23151616%22%2F%3E%3Cpath%20d%3D%22M24.384%2023.59c2.544%200%205.768.132%208.481.132.679%200%202.036-.226%202.544.226.509.45.171%201.353.171%202.032-.51%201.582-.679%203.164-.848%204.518-.171.904-.171%201.808-.34%202.712-.17.903-.34%201.807-.51%202.484-.168%201.13-.508%202.033-.508%202.938v2.484c0%20.904-.169%202.032.17%202.937.17.452.509%201.356%201.018%201.58.34.226%201.186%200%201.696-.223.34-.227.678-.454%201.017-.904.17-.226.17-.453.51-.453.17.678-.678%202.033-1.187%202.485-.68.677-1.358%201.13-2.206%201.808-.51.45-1.357.904-1.867%201.128-.847.226-1.695.226-2.544.226-.847%200-1.525-.45-2.204-.904-.848-.451-1.696-.904-2.206-1.806-.846-1.357-.676-3.163-.676-4.97%200-1.809.168-3.616.507-5.422.17-.678.34-1.582.679-2.485.17-.452.679-1.13.679-1.808.169-.678%200-1.356%200-2.26%200-.902.169-2.032-.34-2.71-.678-.903-1.695%200-2.034-1.355-.171-.452%200-1.13%200-1.582%200-.452%200-.903-.171-1.355l.169.546z%22%20fill%3D%22%23fefefe%22%2F%3E%3Cpath%20d%3D%22M34.26%2048.082c-1.444%201.079-3.104%201.634-4.773%201.278-1.876-.4-4.063-2.098-4.344-4.678-.248-2.285-.037-4.954.332-7.181.28-1.692.961-3.004%201.41-4.562.344-1.194.187-3.033.1-4.273-.055-.807-.254-1.488-.825-1.884-.688-.48-.907.13-1.325-1.045-.22-.618-.235-1.224-.291-1.853%201.633.006%203.267.048%204.9.084%201.435.03%202.977-.185%204.4.003.605.08%201.339.382%201.573%201.34.114.464-.223%201.136-.325%201.554-.232.952-.36%201.928-.494%202.91-.284%202.074-.554%204.083-.98%206.117-.359%201.7-.442%203.078-.457%204.845-.013%201.52-.173%203.005.582%204.283.4.681.82%201.01%201.475.99%201.036-.03%201.539-.937%202.306-1.466-.328%201.667-2.381%202.88-3.264%203.538m3.415-4.31c-.505.225-.746.757-1.21%201.115-1.106.852-2.256.391-2.747-1.233-.463-1.528-.234-4.73.057-6.282.706-3.751%201.324-7.52%202.012-11.263.456-2.473-.678-2.774-2.268-2.717-3.004.11-6.01-.08-9.014-.095l-.107-.348c-.089-.287-.466-.246-.387.112.271%201.237-.287%203.164.785%203.9.22.151.441.066.65.178.714.384%201%201.286%201.115%202.286.15%201.318.068%202.716-.377%203.896a22.216%2022.216%200%2000-1.41%206.316c-.151%201.928-.393%204.494.15%206.353.985%203.357%204.782%204.394%207.15%203.89%201.412-.3%202.656-1.373%203.852-2.363.858-.71%202.139-1.85%202.071-3.408-.01-.204-.163-.407-.323-.337%22%20fill%3D%22%23151616%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat, no-repeat;
  background-color: #f9f9f9;
  background-position: top left, bottom left;
  background-size: auto 3.75rem, 80% auto;
  border-radius: 1rem;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;
const StyledHeadline = css `
  text-align: center;
  padding: 0 4.5rem;
  margin-bottom: 1rem;

  ${media.mobileM `
    text-align: left;
    padding: 0 3rem 0 8.4rem;
  `};

  ${media.mobileL `
    text-align: left;
    padding: 0 3rem 0 9.4rem;
  `};

  ${media.tablet `
    text-align: left;
    padding: 0;
    margin: 0.5rem 0;
  `};
`;
const HeadlineMobile = styled(Headline2) `
  ${StyledHeadline};

  display: block;

  ${media.tablet `
    display: none;
  `}
`;
const HeadlineDesktop = styled(Headline2) `
  ${StyledHeadline};

  display: none;

  ${media.tablet `
    display: block;
  `}
`;
const CloseButton = styled.button `
  background: none;
  border: none;
  cursor: pointer;
  color: ${props => props.theme.colors.darkergrey};
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  height: ${DISMISS_ICON_SIZE}px;
  padding: 0;
  transition: transform 0.25s ease-out;

  &:focus,
  &:hover {
    transform: rotate(-180deg);
  }

  ${FocusStyles}

  ${media.tablet `
    right: 1.25rem;
    top: 1.25rem;
  `}
`;
export const InfoCard = ({ onClose = undefined, media = null, content, headline, 'data-trackingid': dataTrackingId, }) => {
    const { t } = useTranslation('InfoCard');
    return (React.createElement(Card, { "data-testid": "info-card" },
        React.createElement(Wrapper, null,
            React.createElement(CloseButton, { "aria-label": t('DismissCard'), "data-testid": "infocard-dismiss-button", "data-trackingid": dataTrackingId, onClick: onClose, type: "button" },
                React.createElement(Icon, { height: DISMISS_ICON_SIZE, type: icons.closeX, width: DISMISS_ICON_SIZE })),
            React.createElement(HeadlineMobile, null, headline),
            React.createElement(Inner, null,
                React.createElement(Media, null, media),
                React.createElement(Content, null,
                    React.createElement(HeadlineDesktop, null, headline),
                    React.createElement(Paragraph, { size: 2 }, content))))));
};
